import './accordion.scss';
export const accordionState = {
    index: 0,
    getState(i) {
        return this.index === i ? 'open' : 'collapsed';
    },
    sectionClick(i) {
        this.index = i;
    },
};
